import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("title", null, "alert / info", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("desc", null, "Created with Sketch.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", {
  id: "alert-/-info",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle",
      stroke: "#979797",
      fill: "#D8D8D8",
      opacity: "0",
      x: "0",
      y: "0",
      width: "24",
      height: "24"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "gst-svg-icon",
      d: "M12,3 C7.0275,3 3,7.0275 3,12 C3,16.9725 7.0275,21 12,21 C16.9725,21 21,16.9725 21,12 C21,7.0275 16.9725,3 12,3 Z M12.9,16.5 L11.1,16.5 L11.1,11.1 L12.9,11.1 L12.9,16.5 Z M12.9,9.3 L11.1,9.3 L11.1,7.5 L12.9,7.5 L12.9,9.3 Z",
      id: "Shape",
      fill: "#23262D",
      "fill-rule": "nonzero"
    })
  ])
], -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render };